import React from "react";
import styled, { withTheme } from "styled-components";
import moment from "moment";
import mceIcon from "../../../../assets/svg/mce-hce-icon.svg";

const StyledDiv = styled.div`
  min-height: 2em;
  border-radius: 5px;
  margin-top: 10px;
  background-color: ${(props) => props.theme?.whiteSmoke};
  padding-top: 0.2em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: inherit;
    padding-right: 5px;

    @media (max-width: 647px) {
      .col-sm-1 {
        max-width: 45px;
      }
    }
  }
`;

const StyledFirstCol = styled.div`
  flex: 1;
  min-width: 0;
  margin-right: 20px;
`;

const StyledLastCol = styled.div`
  text-align: end;
  align-items: center;
`;

const StyledBadge = styled.span`
  color: ${(props) => props.theme?.darkPurple};
  font-size: 1rem;
  cursor: pointer;
  vertical-align: middle;
`;

const StyledText = styled.div`
  cursor: pointer;
  margin-right: auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  &:hover {
    text-decoration: underline;
  }
`;

const CompleteIcon = styled.i`
  color: ${(props) => props?.theme?.lightGreen};
  font-size: 20px;
`;

const FlagIcon = styled.i`
  color: ${(props) => props?.theme?.chiliRed};
  font-size: 1rem;
  margin-right: 5px;
`;

const MceIcon = styled.img`
  color: #383838;
  height: 1rem;
  margin-right: 5px;
`;

const StyledElement = (props) => {
  const { index, element, onEdit, canEdit, actionButtonInactive } = props;
  return (
    <StyledDiv
      data-testid="entry-record"
      className="row"
      key={`styled-index-${index}`}
    >
      <StyledFirstCol>
        <div className="text-center mx-3 px-0">
          {canEdit && (
            <StyledBadge
              data-testid="edit-button"
              className="fas fa-pencil-alt"
              onClick={(e) => onEdit(element)}
            />
          )}

          {(element.completed || actionButtonInactive) && (
            <span className="align-middle">
              <CompleteIcon className="fas fa-check-circle" />
            </span>
          )}
        </div>

        <StyledText
          data-testid="view-button"
          onClick={(e) =>
            onEdit({
              ...element,
              readOnly: true,
            })
          }
        >
          {element.title}
        </StyledText>
      </StyledFirstCol>

      <StyledLastCol>
        {element.is24hRecall && <FlagIcon className="fas fa-flag" />}
        {element.hceMceEvent && <MceIcon src={mceIcon} />}
        {moment(element.date).format("h:mm A")}
      </StyledLastCol>
    </StyledDiv>
  );
};

export default withTheme(StyledElement);
